// LIFE-3171 - remove directory if Underwriting Funnel Remix experiment loses
import { FUNNEL_REMIX_HS_COMPLETE } from 'containers/App/constants';
import useSelector from 'store/useSelector';
import { Experiments, Variations, isVariationActive } from 'util/optimizelyHelpers';

export default () => {
  const isExperimentActive = isVariationActive(
    Experiments.LIFE_UNDERWRITING_FUNNEL_REMIX_EXPERIMENT_NAME,
    Variations.LIFE_UNDERWRITING_FUNNEL_REMIX_VARIANT_NAME
  );

  const activeUserUuid = useSelector((app) => app.activeUserUuid);

  const isHouseHoldComplete = !!localStorage.getItem(
    `${FUNNEL_REMIX_HS_COMPLETE}-${activeUserUuid}`
  );

  return isExperimentActive && isHouseHoldComplete;
};
